import React, { useState, useEffect, useRef } from 'react';
import '../pages/SnapCamera/CameraApp.css';

import { Close } from '@mui/icons-material';


export default function Overlay({ isOpen, onClose, children }) {


    const overlayContentRef = useRef(null);
    

    useEffect(() => {
        const originalBodyOverflow = document.body.style.overflow;

        if (isOpen) {
            document.body.style.overflow = 'hidden';
                }
        else {
            document.body.style.overflow = originalBodyOverflow;
        }

        return () => {
            document.body.style.overflow = originalBodyOverflow;
        }
    }, [isOpen]);




    if (!isOpen) {
        return null;
    }

    let contentStyle = {
        transition: 'width 0.3s ease, height 0.3s ease, border-radius 0.3s ease, background-color 0.3s ease',
        borderRadius: '8px',
        backgroundColor: 'rgba(220, 220, 220, 0.1)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        height: '470px',
    };

  





    return (
        <>
            <div
                className='w-full flex justify-end items-center p-2 bg-transparent space-x-2'
                style={{ flexShrink: 0, cursor: 'default' }}
                onClick={(e) => e.stopPropagation()}
            >
                {onClose && (
                    <button title="Close" onClick={(e) => { e.stopPropagation(); onClose(); }}>
                        <Close />
                    </button>
                )}
            </div>

            <div
                className="overlay-inner-content"
                style={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    width: '100%',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </>
    )
}




